module.exports = require('./Popover');
